/* Muxum Quiz — "Encuentra tu hongo"
 * 5 preguntas hardcoded. Q1 determina familia, Q4 formato.
 * Estado en módulo cerrado, persistencia en localStorage, deep-link via ?result=<family>.
 * Productos serializados desde Liquid en window.MUXUM_QUIZ_PRODUCTS.
 */
(function () {
  'use strict';

  const QUIZ_DATA = [
    {
      id: 'goal',
      q: '¿Qué te trae a Muxum?',
      help: 'Elige lo que más resuena hoy. No es definitivo.',
      options: [
        { v: 'energy', l: 'Más energía sin crash', family: 'cordyceps', icon: 'zap' },
        { v: 'focus', l: 'Enfoque y claridad mental', family: 'melena-de-leon', icon: 'brain' },
        { v: 'sleep', l: 'Dormir mejor, bajar revoluciones', family: 'reishi', icon: 'moon' },
        { v: 'immunity', l: 'Reforzar mi inmunidad', family: 'cola-de-pavo', icon: 'shield' },
      ],
    },
    {
      id: 'time',
      q: '¿Cuándo lo tomarías?',
      help: 'El momento ideal varía según el hongo.',
      options: [
        { v: 'morning', l: 'Antes de mover el día' },
        { v: 'midday', l: 'Cuando se viene la pausa larga' },
        { v: 'evening', l: 'Al cerrar la jornada' },
        { v: 'anytime', l: 'No tengo un horario fijo' },
      ],
    },
    {
      id: 'lifestyle',
      q: '¿Cuál te describe mejor?',
      help: 'Sin juicios, solo contexto para personalizar.',
      options: [
        { v: 'active', l: 'Entreno o me muevo casi a diario' },
        { v: 'creative', l: 'Trabajo creativo / largas horas frente a pantalla' },
        { v: 'busy', l: 'Tengo demasiados pendientes' },
        { v: 'recovering', l: 'Vengo saliendo de algo (estrés, gripa, viaje)' },
      ],
    },
    {
      id: 'format',
      q: '¿Cómo prefieres tu ritual?',
      help: 'Mismo extracto, distinto vehículo.',
      options: [
        { v: 'dropper', l: 'Gotero — sabor a tierra, absorción rápida', formatShort: 'Extracto' },
        { v: 'capsule', l: 'Cápsula — sin sabor, portátil', formatShort: 'Cápsulas' },
        { v: 'either', l: 'Cualquiera, el que funcione mejor', formatShort: 'Extracto' },
      ],
    },
    {
      id: 'experience',
      q: '¿Tu experiencia con hongos funcionales?',
      help: 'Para saber qué tan en detalle explicarte.',
      options: [
        { v: 'new', l: 'Es la primera vez' },
        { v: 'curious', l: 'He probado uno o dos' },
        { v: 'regular', l: 'Los integro a mi rutina' },
        { v: 'expert', l: 'Sé exactamente lo que busco' },
      ],
    },
  ];

  const FAMILY_META = {
    'cordyceps': {
      name: 'Cordyceps',
      tagline: 'Energía limpia para mover el día.',
      character: 'El motor matutino',
      reason: 'Te interesa más energía sin el crash de la cafeína. Cordyceps mejora la oxigenación celular y el rendimiento físico sin estimulantes.',
    },
    'melena-de-leon': {
      name: 'Melena de León',
      tagline: 'Foco y claridad mental sostenida.',
      character: 'El arquitecto del foco',
      reason: 'Necesitas claridad mental para trabajo cognitivo. La Melena de León apoya la producción de NGF y la conexión neuronal.',
    },
    'reishi': {
      name: 'Reishi',
      tagline: 'Calma profunda, descanso real.',
      character: 'El monje nocturno',
      reason: 'Buscas bajar revoluciones y dormir mejor. Reishi modula la respuesta al estrés y favorece un sueño profundo.',
    },
    'cola-de-pavo': {
      name: 'Cola de Pavo',
      tagline: 'Defensas que se construyen día a día.',
      character: 'El guardián silencioso',
      reason: 'Quieres reforzar tu sistema inmune de manera consistente. Cola de Pavo aporta PSK y PSP, dos compuestos estudiados en inmunidad.',
    },
  };

  const STORAGE_KEY = 'muxum:quiz:result';
  const VALID_FAMILIES = Object.keys(FAMILY_META);

  let state = {
    step: 0, // 0 = intro, 1..5 = preguntas, 6 = resultado
    answers: {},
    result: null,
  };

  let mountEl = null;

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  function readDeepLink() {
    try {
      const params = new URLSearchParams(window.location.search);
      const r = params.get('result');
      if (r && VALID_FAMILIES.indexOf(r) !== -1) return r;
    } catch (e) {}
    return null;
  }

  function readStored() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed && VALID_FAMILIES.indexOf(parsed.family) !== -1) return parsed;
    } catch (e) {}
    return null;
  }

  function persist(result) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...result, ts: Date.now() }));
    } catch (e) {}
  }

  function clearStored() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function computeResult() {
    const goal = QUIZ_DATA[0].options.find((o) => o.v === state.answers.goal);
    const format = QUIZ_DATA[3].options.find((o) => o.v === state.answers.format);
    return {
      family: goal ? goal.family : 'cordyceps',
      format: format ? format.formatShort : 'Extracto',
    };
  }

  function getProductForResult(result) {
    const products = window.MUXUM_QUIZ_PRODUCTS || {};
    const p = products[result.family];
    if (!p) return null;
    const variant = (p.variants || []).find((v) => {
      const t = (v.title || '').toLowerCase();
      return result.format === 'Cápsulas' ? t.indexOf('cápsul') !== -1 || t.indexOf('capsul') !== -1 : t.indexOf('extract') !== -1 || t.indexOf('gotero') !== -1;
    }) || (p.variants || [])[0] || null;
    return { product: p, variant };
  }

  function svgIcon(name) {
    const icons = {
      zap: '<path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>',
      brain: '<path d="M9.5 2A2.5 2.5 0 007 4.5v.5a3 3 0 00-3 3v1a3 3 0 00.5 1.66A3 3 0 005 14a3 3 0 003 3v.5A2.5 2.5 0 0010.5 20h0a2.5 2.5 0 002.5-2.5V4.5A2.5 2.5 0 0010.5 2h-1zM14.5 2A2.5 2.5 0 0117 4.5v.5a3 3 0 013 3v1a3 3 0 01-.5 1.66A3 3 0 0119 14a3 3 0 01-3 3v.5a2.5 2.5 0 01-2.5 2.5h0a2.5 2.5 0 01-2.5-2.5"/>',
      moon: '<path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>',
      shield: '<path d="M12 2l9 4v6c0 5-4 9-9 10-5-1-9-5-9-10V6l9-4z"/><path d="M9 12l2 2 4-4"/>',
    };
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (icons[name] || '') + '</svg>';
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function progressBar() {
    const total = QUIZ_DATA.length;
    const pct = state.step === 0 ? 0 : state.step > total ? 100 : ((state.step - 1) / total) * 100 + (1 / total) * 100 * 0.5;
    return '<div class="mx-quiz__progress" aria-hidden="true"><div class="mx-quiz__progress-fill" style="width: ' + pct.toFixed(1) + '%"></div></div>';
  }

  function renderIntro() {
    return [
      '<div class="mx-quiz__intro">',
      '  <span class="mx-eyebrow">Encuentra tu hongo</span>',
      '  <h1 class="mx-display-lg">Cinco preguntas y te decimos por dónde empezar.</h1>',
      '  <p class="mx-lede">No vas a "encontrar tu match perfecto" — los hongos no funcionan así. Pero sí podemos darte un punto de partida que tenga sentido para ti.</p>',
      '  <ul class="mx-quiz__meta">',
      '    <li>· 5 preguntas</li>',
      '    <li>· ~90 segundos</li>',
      '    <li>· Sin email, sin truco</li>',
      '  </ul>',
      '  <button type="button" class="mx-btn mx-btn--ink mx-btn--lg" data-quiz-start>Empezar quiz →</button>',
      '</div>',
    ].join('');
  }

  function renderQuestion(qIndex) {
    const q = QUIZ_DATA[qIndex];
    if (!q) return '';
    const selected = state.answers[q.id];
    const optionsHtml = q.options.map(function (opt) {
      const isActive = selected === opt.v;
      const iconHtml = opt.icon ? '<span class="mx-quiz__opt-icon">' + svgIcon(opt.icon) + '</span>' : '';
      return [
        '<button type="button" class="mx-quiz__opt' + (isActive ? ' is-active' : '') + '" data-quiz-answer="' + escapeHtml(opt.v) + '">',
        iconHtml,
        '<span class="mx-quiz__opt-label">' + escapeHtml(opt.l) + '</span>',
        '</button>',
      ].join('');
    }).join('');
    return [
      '<div class="mx-quiz__question">',
      progressBar(),
      '  <div class="mx-quiz__q-head">',
      '    <span class="mx-eyebrow">Pregunta ' + (qIndex + 1) + ' de ' + QUIZ_DATA.length + '</span>',
      '    <h2 class="mx-display-md">' + escapeHtml(q.q) + '</h2>',
      q.help ? '    <p class="mx-quiz__help">' + escapeHtml(q.help) + '</p>' : '',
      '  </div>',
      '  <div class="mx-quiz__options">' + optionsHtml + '</div>',
      '  <div class="mx-quiz__nav">',
      qIndex > 0 ? '    <button type="button" class="mx-btn mx-btn--ghost mx-btn--sm" data-quiz-back>← Atrás</button>' : '<span></span>',
      '  </div>',
      '</div>',
    ].join('');
  }

  function renderResult() {
    const result = state.result || readStored() || computeResult();
    const meta = FAMILY_META[result.family] || FAMILY_META.cordyceps;
    const productInfo = getProductForResult(result);
    const productHtml = productInfo && productInfo.product ? [
      '<a class="mx-quiz__product-card" href="' + escapeHtml(productInfo.product.url || '#') + '">',
      productInfo.product.image ? '  <div class="mx-quiz__product-img"><img src="' + escapeHtml(productInfo.product.image) + '" alt="' + escapeHtml(productInfo.product.title || meta.name) + '" loading="lazy"></div>' : '',
      '  <div class="mx-quiz__product-info">',
      '    <span class="mx-eyebrow">' + escapeHtml(result.format) + '</span>',
      '    <h3 class="mx-display-sm">' + escapeHtml(productInfo.product.title || meta.name) + '</h3>',
      productInfo.product.price ? '    <p class="mx-quiz__product-price">' + escapeHtml(productInfo.product.price) + '</p>' : '',
      '    <span class="mx-btn mx-btn--ink mx-btn--block">Ver producto →</span>',
      '  </div>',
      '</a>',
    ].join('') : '<a class="mx-btn mx-btn--ink mx-btn--lg" href="/products/' + escapeHtml(result.family) + '">Ver ' + escapeHtml(meta.name) + ' →</a>';

    const shareUrl = window.location.origin + window.location.pathname + '?result=' + encodeURIComponent(result.family);
    return [
      '<div class="mx-quiz__result">',
      '  <span class="mx-eyebrow">Tu match</span>',
      '  <h1 class="mx-display-lg">' + escapeHtml(meta.name) + '</h1>',
      '  <p class="mx-quiz__result-tag">' + escapeHtml(meta.tagline) + '</p>',
      '  <p class="mx-quiz__result-character">' + escapeHtml(meta.character) + '</p>',
      '  <p class="mx-quiz__result-reason">' + escapeHtml(meta.reason) + '</p>',
      '  <div class="mx-quiz__result-product">' + productHtml + '</div>',
      '  <div class="mx-quiz__result-actions">',
      '    <button type="button" class="mx-btn mx-btn--ghost" data-quiz-restart>Rehacer quiz</button>',
      '    <a class="mx-btn mx-btn--ghost" href="/pages/hongos/' + escapeHtml(result.family) + '">Conocer más sobre ' + escapeHtml(meta.name) + '</a>',
      '    <button type="button" class="mx-btn mx-btn--ghost" data-quiz-share data-share-url="' + escapeHtml(shareUrl) + '">Compartir resultado</button>',
      '  </div>',
      '</div>',
    ].join('');
  }

  function render() {
    if (!mountEl) return;
    let html;
    if (state.step === 0) html = renderIntro();
    else if (state.step > QUIZ_DATA.length) html = renderResult();
    else html = renderQuestion(state.step - 1);
    mountEl.innerHTML = html;
    bindEvents();
    if (state.step > 0 && state.step <= QUIZ_DATA.length) {
      mountEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function bindEvents() {
    const startBtn = mountEl.querySelector('[data-quiz-start]');
    if (startBtn) startBtn.addEventListener('click', start);

    const optBtns = mountEl.querySelectorAll('[data-quiz-answer]');
    optBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { answer(btn.getAttribute('data-quiz-answer')); });
    });

    const backBtn = mountEl.querySelector('[data-quiz-back]');
    if (backBtn) backBtn.addEventListener('click', back);

    const restartBtn = mountEl.querySelector('[data-quiz-restart]');
    if (restartBtn) restartBtn.addEventListener('click', restart);

    const shareBtn = mountEl.querySelector('[data-quiz-share]');
    if (shareBtn) shareBtn.addEventListener('click', function () {
      const url = shareBtn.getAttribute('data-share-url');
      if (navigator.share) {
        navigator.share({ title: 'Mi resultado del quiz Muxum', url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          shareBtn.textContent = '¡Link copiado!';
          setTimeout(function () { shareBtn.textContent = 'Compartir resultado'; }, 2000);
        });
      }
    });
  }

  function start() {
    state.step = 1;
    state.answers = {};
    emit('muxum:quiz:start', {});
    render();
  }

  function answer(value) {
    const qIndex = state.step - 1;
    const q = QUIZ_DATA[qIndex];
    if (!q) return;
    state.answers[q.id] = value;
    emit('muxum:quiz:step', { step: state.step, qid: q.id, value: value });
    if (state.step >= QUIZ_DATA.length) {
      const result = computeResult();
      state.result = result;
      state.step = QUIZ_DATA.length + 1;
      persist(result);
      emit('muxum:quiz:result', result);
    } else {
      state.step += 1;
    }
    render();
  }

  function back() {
    if (state.step > 1) {
      state.step -= 1;
      render();
    }
  }

  function restart() {
    state.step = 0;
    state.answers = {};
    state.result = null;
    clearStored();
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('result');
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
    render();
  }

  function init() {
    mountEl = document.querySelector('[data-muxum-quiz]');
    if (!mountEl) return;

    const deepLink = readDeepLink();
    if (deepLink) {
      state.result = { family: deepLink, format: 'Extracto' };
      state.step = QUIZ_DATA.length + 1;
    }
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
